// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 561 ? "homeview" : chunkId) + "." + {"318":"6d45b629","561":"0ac86dc3","604":"7af8fa47"}[chunkId] + ".css";
};